var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintReportIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.5C10.5 14.775 10.275 15 10 15H2C1.725 15 1.5 14.775 1.5 14.5V2.5C1.5 2.225 1.725 2 2 2H7V4.5C7 5.05312 7.44688 5.5 8 5.5H10.5V8.5H12V5.32812C12 4.79688 11.7906 4.2875 11.4156 3.9125L8.58438 1.08438C8.20938 0.709375 7.70312 0.5 7.17188 0.5H2C0.896875 0.5 0 1.39688 0 2.5V14.5C0 15.6031 0.896875 16.5 2 16.5H10C11.1031 16.5 12 15.6031 12 14.5V12H10.5V14.5ZM15.2812 7.21875C14.9875 6.925 14.5125 6.925 14.2219 7.21875C13.9313 7.5125 13.9281 7.9875 14.2219 8.27812L15.4406 9.49687H6.75C6.33437 9.49687 6 9.83125 6 10.2469C6 10.6625 6.33437 10.9969 6.75 10.9969H15.4406L14.2219 12.2156C13.9281 12.5094 13.9281 12.9844 14.2219 13.275C14.5156 13.5656 14.9906 13.5687 15.2812 13.275L17.7812 10.775C18.075 10.4812 18.075 10.0062 17.7812 9.71562L15.2812 7.21562V7.21875Z",
    fill: "#8A0538"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintReportIcon);
export default __webpack_public_path__ + "static/media/PrintReportIcon.5f395241dd1c0b93e86447a19aba17f6.svg";
export { ForwardRef as ReactComponent };